import { render, staticRenderFns } from "./PreviewCard.vue?vue&type=template&id=1c9fe8d5&scoped=true&"
import script from "./PreviewCard.vue?vue&type=script&lang=js&"
export * from "./PreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./PreviewCard.vue?vue&type=style&index=0&id=1c9fe8d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9fe8d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c9fe8d5')) {
      api.createRecord('1c9fe8d5', component.options)
    } else {
      api.reload('1c9fe8d5', component.options)
    }
    module.hot.accept("./PreviewCard.vue?vue&type=template&id=1c9fe8d5&scoped=true&", function () {
      api.rerender('1c9fe8d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/ui/PreviewCard.vue"
export default component.exports